import { PermissionEnum } from "@dashboard/graphql";

export const MANAGE_SUBSCRIPTION_PERMISSION = "MANAGE_SUBSCRIPTION" as PermissionEnum;
